import type { Event } from '@mb/types';
import { createSlice } from '@reduxjs/toolkit';

interface EventsState {
  eventsList: Event[];
  upcomingEvents: Event[];
  errorMessage: string | null;
  loaded: boolean;
}

export const initialState: EventsState = {
  eventsList: [],
  upcomingEvents: [],
  errorMessage: null,
  loaded: false,
};

const eventsSlice = createSlice({
  name: 'events',
  initialState,
  reducers: {
    setEventsList(state, { payload }) {
      state.eventsList = payload;
    },
    setErrorMessage(state, { payload }) {
      state.errorMessage = payload;
    },
    setLoaded(state, { payload }) {
      state.loaded = payload;
    },
  },
});

export const { setEventsList, setErrorMessage, setLoaded } =
  eventsSlice.actions;

export default eventsSlice.reducer;
